module.exports = __webpack_public_path__ + "img/xk.4f3781c.svg";